import React, { createContext, useContext, useState, ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { useToggleReleasePopupMutation } from "../utils/custom hooks/useReleasePopupToggle";
import useProfile from "../utils/custom hooks/useProfile";

interface AdminContextType {
  // Tour functionality
  isTourActive: boolean;
  startTour: () => void;
  closeTour: () => void;

  // Patient Popup functionality
  isPatientPopupEnabled: boolean;
  setIsPatientPopupEnabled: any;
  togglePatientPopup: () => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const AdminProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // Tour state and functions
  const history = useHistory();
  const [isTourActive, setIsTourActive] = useState(false);
  const { mutation } = useToggleReleasePopupMutation();
  const { data:profile } = useProfile()
  const startTour = () => {
    setIsTourActive(true);
  };
  const handleToggle = (enabled: boolean) => {
    mutation.mutate({ isReleasePopupButtonEnabled: enabled });
  };
  const closeTour = () => {
    if (profile?.user?.isReleasePopupButtonEnabled) {
      handleToggle(false);
    }
    setIsTourActive(false);
    history.push("/access/dashboard", { state: undefined });
  };

  // Patient Popup state and function
  const [isPatientPopupEnabled, setIsPatientPopupEnabled] = useState(false);

  const togglePatientPopup = () => setIsPatientPopupEnabled((prev) => !prev);

  return (
    <AdminContext.Provider
      value={{
        isTourActive,
        startTour,
        closeTour,
        isPatientPopupEnabled,
        togglePatientPopup,
        setIsPatientPopupEnabled,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = (): AdminContextType => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdminContext must be used within an AdminProvider");
  }
  return context;
};
